<title>{{ ndcRegistrationPage.htmlTitle }}</title>
<app-banner [banner]="ndcRegistrationPage.banner" [isCommonBanner]="true" [isDefaultPageBanner]="false"></app-banner>
<div class="container mt-5">
  <div class="row">
    <div class="container">
      <app-section [sections]="ndcRegistrationPage.sectionAboveNote"></app-section>
      <img class="content-image" style="background-image: url('{{ ndcRegistrationPage.banner && ndcRegistrationPage.banner.image }}');" />
    </div>

    <div class="col-md-12 col-xs-12">
      <div class="lift innerContent pt-4">
        <app-note [noteSections]="ndcRegistrationPage.noteSections"></app-note>
        <app-section [sections]="ndcRegistrationPage.sectionBelowNote"></app-section>
        <app-ndc-registrations-saleshub-card class="mt-5" [salesHubCategory]="ndcRegistrationPage.salesHubCategory"> </app-ndc-registrations-saleshub-card>
      </div>
    </div>
  </div>

  <app-ndc-registration-card [ndcRegistrationCards]="ndcRegistrationPage.ndcRegistrationCards"> </app-ndc-registration-card>
</div>
